import { useEffect } from 'react';

import useDidMount from '../../../hooks/useDidMount';
import { BaseRootStore } from '../../rootStore/baseRootStore';
import { calculateTotalUsedSeats } from '../helpers/functions/totalUsedSeats';

export default function useTotalUsedSeats(rootStore: BaseRootStore) {
  const { userStore, areaUnitStore } = rootStore;
  const { areaUnit } = areaUnitStore;

  const totalUsedSeats = calculateTotalUsedSeats(
    userStore.userDataOrganizations.orgs,
    userStore.combinedData.userData?.uuid ?? '',
  );

  useDidMount(() => {
    void userStore.fetchCombinedData();
  });

  useEffect(() => {
    if (!areaUnit) {
      return;
    }

    void userStore.fetchOrganizationsUsers({ areaUnit });
  }, [areaUnit, userStore]);

  return {
    loading:
      userStore.combinedData.loading || userStore.userDataOrganizations.loading,
    loaded:
      userStore.combinedDataLoaded && userStore.userDataOrganizationsLoaded,
    totalUsedSeats,
  };
}
